var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.$emit('submit');
      }
    }
  }, [_vm.title ? _c('title-text', {
    staticClass: "my-md-3"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('card', {
    staticClass: "position-relative"
  }, [_c('loader', {
    attrs: {
      "enable": _vm.loading
    }
  }), _vm.messageError ? _c('message', {
    staticClass: "mb-3",
    attrs: {
      "type": 'error'
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageError)
    }
  })]) : _vm._e(), _vm.messageInfo ? _c('message', {
    staticClass: "mb-3",
    attrs: {
      "icon": true,
      "type": 'info'
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.messageInfo)
    }
  })]) : _vm._e(), _vm._t("default"), _c('div', {
    staticClass: "row justify-content-between mt-4"
  }, [_vm.backBtnText ? _c('div', {
    staticClass: "col text-left"
  }, [_c('RoundedButton', {
    attrs: {
      "data-qa": _vm.backBtnQA,
      "label": _vm.backBtnText
    },
    on: {
      "buttonClicked": function ($event) {
        return _vm.$emit('back');
      }
    }
  })], 1) : _vm._e(), _vm.submitBtnText ? _c('div', {
    staticClass: "col text-right"
  }, [_c('RoundedButton', {
    attrs: {
      "data-qa": _vm.submitBtnQA,
      "label": _vm.submitBtnText,
      "type": 'reversed'
    },
    on: {
      "buttonClicked": function ($event) {
        return _vm.$emit('submit');
      }
    }
  })], 1) : _vm._e()])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }